import React from "react";
import OfferRow from "./OfferRow/OfferRow";
import styles from "./OfferList.module.css";

import type {
  AdminOffer,
} from "../../../slices/adminOffer/adminOfferSlice";

interface OfferListProps {
  offers: AdminOffer[];
}

const OfferList: React.FC<OfferListProps> = ({
  offers,
}) => {
  if (!offers.length) {
    return (
      <div className={styles.Empty}>
        Brak wizytówek do wyświetlenia.
      </div>
    );
  }

  return (
    <div className={styles.List}>
      <div className={styles.Header}>
        <div>Firma:</div>
        <div>Właściciel:</div>
        <div>Przypisanie:</div>
        <div>Ważna do:</div>
        <div>Status:</div>
      </div>

      {offers.map((offer) => (
        <OfferRow
          key={offer._id}
          offer={offer}
        />
      ))}
    </div>
  );
};

export default OfferList;